import { render, staticRenderFns } from "./ModificacionAutomatica.vue?vue&type=template&id=a3bec21a"
import script from "./ModificacionAutomatica.vue?vue&type=script&lang=js"
export * from "./ModificacionAutomatica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports